'use client'

import { FC } from 'react'
import { CardTokenizationProviderProps } from '~types/index'

import { OPMProvider } from '@mercadoni/sinister/dist/cjs/checkout/contexts'
import MiddleWare from './MiddleWare'

export const CardTokenizationProvider: FC<CardTokenizationProviderProps> = ({
  children,
  clientModel,
}) => {
  return (
    <OPMProvider>
      <MiddleWare clientModel={clientModel}>{children}</MiddleWare>
    </OPMProvider>
  )
}
